<template>
  <div class="layout-wrapper-portal">
    <section class="navbartop bg-white shadow">
      <nav class="navbar py-4 navbar-expand-lg navbar-light">
        <div class="container-fluid px-4 py-2">
          <Link class="navbar-brand pe-4" href="/">
            <img src="/img/disperindag.png" alt="Disperindag" style="height: 64px;margin: -20px 0;"/>
          </Link>
          <button class="navbar-toggler" type="button" @click="navcollapse_show = !navcollapse_show">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse mt-4 mt-md-0" :class="{ 'show': navcollapse_show }" style="font-weight: bold;">
            <ul class="navbar-nav me-auto mb-2 gap-4 mb-lg-0">
              <li class="nav-item">
                <Link class="nav-link" href="/artikel">Artikel</Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link" href="/postingan">Berita</Link>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link cp">Galeri</a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link cp" href="/geospasial" target="_blank">Geospasial</a>
              </li>
              <li class="nav-item">
                <a class="nav-link dropdown-toggle cp" @click="navdropdown_show == 'tentang' ? navdropdown_show = false : navdropdown_show = 'tentang'">Profil</a>
                <ul class="dropdown-menu" :class="{ 'show': navdropdown_show == 'tentang' }">
                  <li><a class="dropdown-item" href="#">Sejarah Singkat</a></li>
                  <li><a class="dropdown-item" href="#">Visi dan Misi</a></li>
                  <li><hr class="dropdown-divider" /></li>
                  <li><a class="dropdown-item" href="#">Tentang</a></li>
                </ul>
              </li>
            </ul>
            <form class="d-flex">
              <input class="form-control bg-light" type="search" name="q" placeholder="Cari .." aria-label="Cari .." style="border-top: none;border-left: none;border-right: none;border-radius: 0;outline: none;" />
              <button class="btn btn-success me-2" type="submit" style="border-radius: 0;">
                <Icon :icon="['fa', 'search']" />
              </button>
              <Link href="/auth/login" class="btn btn-link">Login</Link>
            </form>
          </div>
        </div>
      </nav>
    </section>

    <slot></slot>

    <section class="footer bg-dark">
      <div class="container">
        <footer class="py-4 text-light text-end">
          <p>Copyright 2022 &copy; Disperindag - Provinsi Maluku Utara</p>
        </footer>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  
}
</script>


<style lang="scss">
@import '../../css/bootstrap';
@import '../../css/style';
</style>